import { useState, useEffect, MouseEventHandler } from 'react';
import { useStore } from '@ui/hooks/useStore';
import useKeyDown from '@ui/hooks/useKeyDown';
import getLiElementId from '@utils/getLiElementId';
import { ICloseEvent } from '@core/interfaces/ICloseEvent';
import { IState } from './IState';

const useSubuserDevices = (onClose: ICloseEvent['onClose']) => {
    const { subusers, devices, lang } = useStore();
    const key = useKeyDown();

    const initState: IState = {
        deviceBtnHover: false,
        deleteDeviceVisible: false,
        editSubuserRightsVisible: false,
    };
    const [state, setState] = useState(initState);

    const handleKey = (key: string) => {
        switch (key) {
            case 'Escape':
                onClose();
                break;
        }
    };
    const handleDeviceBtnHoverStart = () => {
        setState((prev) => ({ ...prev, deviceBtnHover: true }));
    };
    const handleDeviceBtnHoverStop = () => {
        setState((prev) => ({ ...prev, deviceBtnHover: false }));
    };
    const handleDeleteDeviceOpen: MouseEventHandler<HTMLElement> = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const imei = getLiElementId(e.target as HTMLElement);
        if (imei) {
            subusers.setSelectedDevice(imei);
            setState((prev) => ({ ...prev, deleteDeviceVisible: true }));
        }
    };
    const handleDeleteDeviceClose = () => {
        setState((prev) => ({ ...prev, deleteDeviceVisible: false }));
        subusers.resetSelectedDevice();
    };
    const handleEditSubuserRightsOpen: MouseEventHandler<HTMLElement> = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const imei = getLiElementId(e.target as HTMLElement);
        if (imei) {
            subusers.setSelectedDevice(imei);
            setState((prev) => ({ ...prev, editSubuserRightsVisible: true }));
        }
    };
    const handleEditSubuserRightsClose = () => {
        setState((prev) => ({ ...prev, editSubuserRightsVisible: false }));
        subusers.resetSelectedDevice();
    };
    const handlers = {
        handleDeviceBtnHoverStart,
        handleDeviceBtnHoverStop,
        handleDeleteDeviceOpen,
        handleDeleteDeviceClose,
        handleEditSubuserRightsOpen,
        handleEditSubuserRightsClose,
    };

    useEffect(() => {
        subusers.resetServerError();
    }, []);
    useEffect(() => {
        handleKey(key);
    }, [key]);

    return {
        subusers,
        devices,
        lang,
        state,
        handlers,
    };
};

export default useSubuserDevices;
